export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "",
        "AI": "",
        "AI CMS": "",
        "Anuluj": "",
        "Asystenta AI": "",
        "Błąd podczas generowania instrukcji": "",
        "Błąd podczas generowania metadanych SEO": "",
        "Błąd podczas generowania opisu produktu": "",
        "Brak kontekstu": "",
        "Brak produktu": "",
        "Brak zdefiniowanego klucza API dla dostawcy ${AiProviders.OPENAI}": "",
        "Format obrazu": "",
        "Generator": "",
        "Generator metadanych SEO": "",
        "Generator obrazów AI": "",
        "Generowanie obrazów zakończone": "",
        "Generuj metadane": "",
        "Generuj obraz": "",
        "Generuj opis": "",
        "Generuj opis produktu": "",
        "Konfiguracja AI": "",
        "Konfiguracja asystenta ai": "",
        "Liczba wariantów": "",
        "Nie udało się wygenerować promptu": "",
        "Nieobsługiwany provider": "",
        "Obraz został pomyślnie opisany": "",
        "Obrazy zostały przeniesione.": "",
        "Opis został wygenerowany": "",
        "Proporcje obrazu": "",
        "Przejdź do konfiguracji, aby włączyć inteligentne narzędzia.": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "",
        "Repozytorium plików": "",
        "Ścieżka zapisu została zmieniona.": "",
        "Trwa generowanie obrazów": "",
        "Trwa generowanie opisu": "",
        "Trwa generowanie opisu dla wybranego obrazu": "",
        "Ustaw ścieżkę": "",
        "Ustawienia (opcjonalne)": "",
        "Użyj wyszukiwarki": "",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "",
        "Wybierz ścieżkę zapisu": "",
        "Wybróbuj możliwości AI": "",
        "Wygeneruj obraz z treści artykułu": "",
        "Wypróbuj możliwości AI": "",
        "Wystąpił problem podczas przesyłania obrazu.": "",
        "Zamknij": "",
        "Zapisywanie obrazów zakończone.": "",
        "Zapisywanie obrazów...": "",
        "Zapisz": "",
        "Zapisz wybrane": "",
        "Zmień ścieżkę zapisu": ""
    }
};
